import React from "react";
import '../../App.css';
import Footer from "../../components/Footer";

function Reviews() {
    return (
        <div >
            <h3>welcome to Review page</h3>
            <Footer/>
            </div>
    )
}

export default Reviews;